module.exports = __webpack_public_path__ + "img/reception.9d8012fd.jpg";